import { useGetTerminalsQuery } from "../gateways/cms/terminalApi";

import { styled } from "@mui/system";
import iconSelectDown from "../assets/icons/icon_arrow_down.svg";

export interface Props {
    value: string;
    required?: boolean;
    disabled?: boolean;
    onChange?: (value: string) => unknown;
}

const SelectWithIcon = styled("select")`
    appearance: none;
    padding-right: 1.8em;
    border-radius: 0;
    background: transparent url(${iconSelectDown}) right center no-repeat scroll;    
`;

export function SelectTerminal({ value, required, disabled, onChange = () => {} }: Props) {
    const terminals = useGetTerminalsQuery({});

    return (
        <SelectWithIcon value={value} required={required} disabled={disabled} onChange={(e) => onChange(e.target.value)}>
            <option value="">未選択</option>
            {terminals.data?.map((terminal) => (
                <option key={terminal.id} value={terminal.id}>
                    {terminal.name}
                </option>
            ))}
        </SelectWithIcon>
    );
}
